function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageHitCreatingProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.521mm",
    height: "14.095mm",
    viewBox: "0 0 18.521 14.095",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -282.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4137 296.08h-0.0253c-0.81264-1e-3 -1.4708-0.65982-1.472-1.4722v-9.3108c1e-3 -0.81243 0.6594-1.4708 1.472-1.4722h2.9651c0.33314-5.8e-4 0.65678 0.11097 0.91856 0.31696l2.129 1.6813c0.42229 0.33233 0.94403 0.51366 1.4813 0.51447h4.5223c0.78009 1e-3 1.4237 0.61048 1.4676 1.3896h-7.8294c-1.036-2e-4 -1.9439 0.69296-2.2164 1.6926l-1.4239 5.1354c-0.24742 0.89592-1.0595 1.5185-1.9889 1.525m14.391-8.2796c-5e-3 -1.3208-1.0789-2.388-2.3999-2.3839h-4.5267c-0.33335 5.7e-4 -0.65699-0.11098-0.91877-0.31697l-2.129-1.6813c-0.42209-0.33233-0.94384-0.51366-1.4813-0.51446h-2.958c-1.3208 1e-3 -2.3908 1.0724-2.3908 2.3932v9.3108c1e-3 1.32 1.0708 2.3896 2.3908 2.391h12.014c1.3465-3e-3 2.5258-0.90259 2.8847-2.2004l1.1484-4.1661c0.33698-1.223-0.38145-2.4874-1.6044-2.8242-0.01-3e-3 -0.019-5e-3 -0.0287-8e-3",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 9.0912886,
    y: 294.7955,
    style: {
      fill: "#ffffff",
      fontFamily: "'Henriette Black'",
      fontSize: "7.8838px",
      fontWeight: 900,
      strokeWidth: 0.20215
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.0912886,
    y: 294.7955,
    style: {
      strokeWidth: 0.20215
    }
  }, "+"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageHitCreatingProject);
export default __webpack_public_path__ + "static/media/image_HitCreatingProject.34808024fab19aa9342c5bbb73c94e9f.svg";
export { ForwardRef as ReactComponent };